export class EventData {
  action: string;
  params: { [id: string]: string | number };
}
